<template>
  <vs-popup class="shipment-update-popup"
            id="popup"
            :title="`UPDATE PRODUCT ORDER COURIER SHIPMENT  ${createForm.courier_shipment_code}`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <template slot="actions">
        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-dropdown>
            <a class="flex items-center" href="#">
              {{ createForm.status.name }}
              <i class="material-icons"> expand_more </i>
            </a>

            <vs-dropdown-menu style="z-index: 110000;" class="w-64" v-can="'create-edit-goods-out-logistics'">

              <vs-dropdown-item v-if="createForm.status.name === 'Dispatch Booked' && checkAbilityToDispatch(createForm.work_orders)"
                @click.stop="onClickShipmentStatusChangeConfirm('shipment_dispatched')">
                Shipment Dispatch
              </vs-dropdown-item>
              
              <vs-dropdown-item v-if="createForm.status.name === 'Shipment Dispatched'" 
                @click.stop="onClickShipmentStatusChangeConfirm('customer_received')">
                Customer Receive
              </vs-dropdown-item>

              <vs-dropdown-item v-if="createForm.status.name === 'Customer Received'"
                @click.stop="onClickShipmentStatusChangeConfirm('returned')">
                Customer Return
              </vs-dropdown-item>

              <vs-dropdown-item v-can="'cancel-goods-out-logistics'" v-if="createForm.status.name === 'Dispatch Booked'"
               @click.stop="onClickShipmentStatusChangeConfirm('cancelled')">
                Shipment Cancel
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          <span v-if="createForm.related_returened_shipment" class="ml-auto mt-2 mr-8">
            <b>Related returned shipment:  <a @click.stop="onClickViewReturnedShipment()" class="cursor-pointer">{{ createForm.related_returened_shipment.courier_shipment_code }}</a> </b>
          </span>

          <span v-if="createForm.related_new_shipment" class="ml-auto mt-2 mr-8">
            <b>Related new shipment:  <a @click.stop="onClickViewNewShipment()" class="cursor-pointer">{{ createForm.related_new_shipment.courier_shipment_code }}</a> </b>
          </span>
          <!-- <vs-chip class="ml-auto mt-2" transparent :color="shipmentStatusColorFactory(createForm.status.name)">
            {{ createForm.status.name }}
          </vs-chip> -->
          <vx-tooltip class="ml-4 mt-1" text="Print/Download Delivery Note" position="top">
            <vs-button @click.stop="onClickDeliveryNote()"
                       size="small" color="warning" type="filled" icon-pack="feather" icon="icon-printer">Delivery note</vs-button>
          </vx-tooltip>
          <vx-tooltip class="ml-4 mt-1" text="VIEW/CREATE POD" position="top">
            <vs-button @click.stop="onClickOpenPod()"
                       size="small" color="primary" type="filled" icon-pack="feather" icon="icon-edit-2">Documents</vs-button>
          </vx-tooltip>

        </div>
      </template>

      <!-- <h5 class="mb-2">Product items</h5> -->

      <!-- Bulk Apply AWB & Delivery Date Section (Collapsible) -->
      <div v-if="createForm.status.name !== 'Dispatch Booked' && createForm.product_items && createForm.product_items.length > 0"
           class="bulk-apply-card mb-4">
        <div class="flex items-center justify-between cursor-pointer select-none"
             @click="showBulkApply = !showBulkApply">
          <div class="flex items-center">
            <feather-icon icon="LayersIcon" svgClasses="w-4 h-4 mr-2 text-primary" />
            <span class="font-semibold text-sm">Quick Apply to All Items</span>
            <span class="text-xs text-muted ml-2">({{ createForm.product_items.length }} items)</span>
          </div>
          <div class="flex items-center text-primary text-xs font-semibold">
            <span>{{ showBulkApply ? 'Hide' : 'Show Bulk Apply' }}</span>
            <feather-icon :icon="showBulkApply ? 'ChevronUpIcon' : 'ChevronDownIcon'" svgClasses="w-4 h-4 ml-1" />
          </div>
        </div>

        <transition name="fade">
          <div v-if="showBulkApply" class="mt-3 pt-3 border-t border-gray-200">
            <p class="text-xs text-muted mb-3">Enter AWB number and/or actual delivery date below to apply to all {{ createForm.product_items.length }} items at once:</p>
            <div class="vx-row items-end">
              <div class="vx-col md:w-5/12 w-full mb-2 md:mb-0">
                <small class="label font-semibold">AWB / Consignment Number</small>
                <vs-input
                  v-model="bulk_awb_consignment_number"
                  placeholder="Enter AWB / consignment number"
                  class="w-full mt-1"
                  icon-pack="feather"
                  icon="icon-hash"
                />
              </div>
              <div class="vx-col md:w-4/12 w-full mb-2 md:mb-0">
                <small class="label font-semibold">Actual Delivery Date</small>
                <flat-pickr
                  class="w-full rounded mt-1 bulk-date-picker"
                  :config="{ dateFormat: 'd/m/Y', maxDate: 'today' }"
                  v-model="bulk_actual_delivery_date"
                  placeholder="Choose Date"
                />
              </div>
              <div class="vx-col md:w-3/12 w-full flex items-center">
                <vs-button
                  @click.prevent="onClickApplyToAllItems"
                  type="filled"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-check-circle"
                  class="w-full"
                  :disabled="!bulk_awb_consignment_number && !bulk_actual_delivery_date"
                >
                  Apply to All
                </vs-button>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateShipment)" autocomplete="off">

        <vs-table :sst="true" :onlyClickCheckbox="true" stripe class="mb-8"  :data="createForm.product_items" :key="JSON.stringify(createForm.id)">

        <template slot="thead">
          <vs-th :width="createForm.status.name === 'Dispatch Booked' ? '60%' : '20%'">ITS PRODUCT CODE</vs-th>
          <vs-th width="15%">ORDER QUANTITY (KG)</vs-th>
          <vs-th width="15%">SHIPPING QUANTITY (KG)</vs-th>
          <vs-th width="25%" v-if="createForm.status.name !== 'Dispatch Booked'">AWB / CONSIGNMENT NUMBER</vs-th>
          <vs-th width="15%" v-if="createForm.status.name !== 'Dispatch Booked'" >Actual Delivery Date</vs-th>
          <vs-th width="10%" class="text-xs" v-if="createForm.product_items.length > 1">ACTION</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="tr.id" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].formulation_code">
              {{ data[indextr].formulation_code  }}
            </vs-td>

            <vs-td :data="data[indextr].order_quantity">
              {{ Number(data[indextr].order_quantity).toFixed(2) }}
            </vs-td>

            <vs-td :data="data[indextr].order_quantity">
<!--              <ValidationProvider :vid="indextr+'shipping_quantity'" :name="indextr+'shipping_quantity'" :rules="'maxoq:'+data[indextr].order_quantity" v-slot="{ errors }">-->
<!--                <vs-input type="text" v-model="data[indextr].shipping_quantity" class="w-full"-->
<!--                          :name="indextr+'shipping_quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"-->
<!--                          val-icon-pack="feather"/>-->
<!--              </ValidationProvider>-->
              {{ data[indextr].shipping_quantity }}

            </vs-td>

            <vs-td v-if="createForm.status.name !== 'Dispatch Booked'">
              <vs-input @input="updateActualDeliveryDate(data[indextr])" v-model="data[indextr].awb_consignment_number" class="w-full"/>
            </vs-td>

           <vs-td :data="data[indextr].item_status" v-if="createForm.status.name !== 'Dispatch Booked'">
              <ValidationProvider :vid="indextr+'actual_delivery_date'" :name="indextr+'actual_delivery_date'" :rules="`required`" v-slot="{ errors }">
                  <flat-pickr style="display: none" class="w-full border border-white" :config="{dateFormat: 'd/m/Y', maxDate: 'today'}"
                    v-model="data[indextr].actual_delivery_date" placeholder="Choose Date"  
                  /> 
                   <flat-pickr @input="updateActualDeliveryDate(data[indextr])" class="w-full border border-white" :config="{dateFormat: 'd/m/Y', maxDate: 'today'}"
                    v-model="data[indextr].actual_delivery_date" placeholder="Choose Date"  
                  />  
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>            
           </vs-td>

            <vs-td v-if="createForm.product_items.length > 1">
              <div class="vx-row">
                <vx-tooltip class="mr-2" text="Remove item from shipment" position="left">
                  <vs-button v-on:click="removeItemFromShipment(data[indextr])"
                             size="small" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>

            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-4/5">
                <vs-table :sst="true" noDataText="" class="my-8" hoverFlat id="order_item_work_order_table" stripe >

                  <template slot="header">
                    <h5 class="mb-4">Work Orders</h5>
                  </template>

                  <template slot="thead">
                    <vs-th width="20%">WO CODE</vs-th>
                    <vs-th width="20%">SO CODE(S)</vs-th>
                    <vs-th width="15%">WO STATUS</vs-th>
                    <vs-th width="15%">WO QC STATUS</vs-th>
                    <vs-th width="15%">SHIPPING QTY (KG)</vs-th>
                    <vs-th width="15%">PACK SIZE (KG)</vs-th>
                  </template>

                  <template>
                    <vs-tr v-if="tr_wo.wo_status !== 'Stopped'" :key="tr_wo.id" v-for="(tr_wo, index_wo) in data[indextr].work_orders">

                      <vs-td :data="tr_wo.work_order_code">
                        <vx-tooltip class="ml-2" text="View Work Order" position="left">
                          <span @click="onClickViewWorkOrder(tr_wo.id)" class="text-primary cursor-pointer">{{ tr_wo.work_order_code }}</span>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td>
                        <span v-if="tr_wo.sales_orders && tr_wo.sales_orders.length">
                          <span v-for="(so, so_index) in tr_wo.sales_orders" :key="so.id">
                            <HyperLink :id="so.id" type="product-order">{{ so.order_code }}</HyperLink><span v-if="so_index < tr_wo.sales_orders.length - 1">, </span>
                          </span>
                        </span>
                        <span v-else>N/A</span>
                      </vs-td>

                      <vs-td :data="tr_wo.status.name">
                        {{ tr_wo.status.name }}
                      </vs-td>

                      <vs-td :data="tr_wo.q_c_test_status">
                        {{ tr_wo.q_c_test_status || 'N/A' }}
                      </vs-td>

                      <vs-td :data="tr_wo.shipping_quantity">
                        {{ Number(tr_wo.shipping_quantity).toFixed(2)}}
                      </vs-td>

                      <vs-td :data="tr_wo.pack_size">
<!--                        <vs-input type="number" v-model="tr_wo.pack_size"-->
<!--                                  class="w-full"-->
<!--                                  :name="index_wo+'pack_size'"-->
<!--                                  val-icon-danger="icon-x"-->
<!--                                  val-icon-pack="feather"/>-->
                        <input :disabled = "!isDispatchBooked" type="number" style="border: 1px solid #CCCCCC; outline: none;" class="w-full h-10 rounded-lg m-2 p-2" v-model="tr_wo.pack_size"/>
                      </vs-td>

                    </vs-tr>
                  </template>

                </vs-table>
              </div>
            </template>

          </vs-tr>
        </template>
      </vs-table>

          <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false">
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="courier_shipment_code" name="courier_shipment_code" rules="required" v-slot="{ errors }">
                  <small class="label">Shipment code</small>
                  <vs-input disabled v-model="createForm.courier_shipment_code"  name="courier_shipment_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="company_name" name="company_name" rules="" v-slot="{ errors }">
                  <small class="label">Courier supplier</small>
                  <vs-input disabled v-model="createForm.supplier.company_name"  name="company_name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div :class="createForm.transport_mode === 'air' ? 'vx-col md:w-1/2 w-full md:mb-0' : 'vx-col md:w-full w-full md:mb-0'">
                <ValidationProvider vid="transport_mode" name="transport_mode" rules="" v-slot="{ errors }">
                  <small class="label">Transport Mode</small>
                  <v-select :disabled="!isDispatchBooked" :clearable="true" placeholder="Select Transport Mode" v-model="createForm.transport_mode"
                            :options="transport_modes" label="label" :reduce="option => option.value"
                            @input="onChangeTransportMode"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="createForm.transport_mode === 'air'">
                <ValidationProvider vid="sub_transport_type" name="sub_transport_type" rules="" v-slot="{ errors }">
                  <small class="label">Sub Transport Type</small>
                  <v-select :disabled="!isDispatchBooked" :clearable="true" placeholder="Select Sub Transport Type" v-model="createForm.sub_transport_type"
                            :options="sub_transport_types" label="label" :reduce="option => option.value"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card-custom>

          <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false">
            <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="date_of_booking" name="date_of_booking" rules="required" v-slot="{ errors }">
                <small class="label">Date of booking</small>
                <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y'}" v-model="createForm.date_of_booking" placeholder="Choose Date"
                />
                <flat-pickr
                  class="w-full"
                  :disabled = "!isDispatchBooked"
                  :config="{ dateFormat: 'd/m/Y'}"
                  v-model="createForm.date_of_booking"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="estimated_delivery_date" name="estimated_delivery_date" rules="required" v-slot="{ errors }">
                <small class="label">Estimated delivery & invoice date</small>
                <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y'}" v-model="createForm.estimated_delivery_date" placeholder="Choose Date"
                />
                <flat-pickr
                  class="w-full"
                  :disabled = "!isDispatchBooked"
                  :config="{ dateFormat: 'd/m/Y'}"
                  v-model="createForm.estimated_delivery_date"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          </vx-card-custom>

          <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false">
            <div class="vx-row mb-8">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="cost_of_delivery" name="cost_of_delivery" rules="required" v-slot="{ errors }">
                <small class="label">Cost of delivery (Excl VAT/TAX) in GBP</small>
                <vs-input :disabled = "!isDispatchBooked" v-model="createForm.cost_of_delivery"  name="cost_of_delivery" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="booking_reference_number" name="booking_reference_number" rules="required" v-slot="{ errors }">
                <small class="label">Booking ref number</small>
                <vs-input :disabled = "!isDispatchBooked" v-model="createForm.booking_reference_number"  name="booking_reference_number" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          </vx-card-custom>

          <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider :vid="'net_weight'"
                                    :name="'net_weight'" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Net Weight (KG)</small>
                  <vs-input :disabled = "!isDispatchBooked" v-model="createForm.net_weight" name="net_weight" class="w-full" label=""
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider :vid="'gross_weight'" :name="'gross_weight'"
                                    rules="required" v-slot="{ errors }">
                  <small class="label">Gross Weight (KG)</small>
                  <vs-input :disabled = "!isDispatchBooked" v-model="createForm.gross_weight" name="gross_weight" class="w-full" label=""
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

          </vx-card-custom>
          <vx-card-custom class="mb-4" :title="''" :cardBorder="true" no-shadow :collapse-action="false">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="sage_department" name="sage_department" rules="required" v-slot="{errors}">
                  <small class="label">Sage Department</small>
                  <v-select :disabled = "!isDispatchBooked" :clearable="false" name="sage_department" placeholder=""
                            label="name" v-model="createForm.sage_department_id" :reduce="option => option.id"
                            :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="region" name="region" rules="required" v-slot="{errors}">
                  <small class="label">Region</small>
                  <v-select :disabled = "!isDispatchBooked" :clearable="false" name="region" placeholder=""
                            label="name" v-model="createForm.region_id" :reduce="option => option.id"
                            :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card-custom>

          <vx-card-custom class="mb-4" :title="'Order Invoices'" :cardBorder="true" no-shadow :collapse-action="false">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <small class="label">Associated Invoices</small>
                <div v-if="createForm.product_order_invoices && createForm.product_order_invoices.length > 0" class="flex flex-wrap items-center mt-2">
                  <vs-chip v-for="invoice in createForm.product_order_invoices" :key="invoice.id" color="primary" class="mr-2 mb-2 font-semibold">
                    {{ invoice.number }}
                  </vs-chip>
                </div>
                <div v-else class="text-sm text-gray-500 mt-1">
                  No invoices associated with this shipment.
                </div>
              </div>
            </div>
          </vx-card-custom>

<!--          <span class="mt-8 mb-4 font-semibold"></span>-->
          <vx-card-custom class="mb-4" :title="'Delivery Address'" :cardBorder="true" no-shadow :collapse-action="false">
            <div class="vx-row mb-3 mt-2">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="address_line_1" name="address_line_1" rules="required" v-slot="{ errors }">
                  <small class="label">Address Line 1</small>
                  <vs-input disabled v-model="createForm.delivery_address.address_line_1"  name="address_line_1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="address_line_2" name="address_line_2" rules="" v-slot="{ errors }">
                  <small class="label">Address Line 2</small>
                  <vs-input disabled v-model="createForm.delivery_address.address_line_2"  name="address_line_2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="address_line_3" name="address_line_3" rules="" v-slot="{ errors }">
                  <small class="label">Address Line 3</small>
                  <vs-input disabled v-model="createForm.delivery_address.address_line_3"  name="address_line_3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="town_state" name="town_state" rules="" v-slot="{ errors }">
                  <small class="label">Town State</small>
                  <vs-input disabled v-model="createForm.delivery_address.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="postcode" name="postcode" rules="required" v-slot="{ errors }">
                  <small class="label">Postal Code</small>
                  <vs-input disabled v-model="createForm.delivery_address.postcode"  name="postcode" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                  <small class="label">Country</small>
                  <vs-input disabled v-model="createForm.delivery_address.country"  name="country" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
          </vx-card-custom>

          <vx-card-custom  v-if="createForm.package_details.length > 0" :title="'Package Details'" :cardBorder="true" no-shadow :collapse-action="false">

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="supplier_id" name="supplier_id" rules="required" v-slot="{ errors }">
                  <small class="label">Type</small>
                  <v-select :disabled = "!isDispatchBooked" :clearable="false" v-model="createForm.type" :options="types" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="separate_item_count" name="separate_item_count" rules="required" v-slot="{ errors }">
                  <small class="label">How many separate items in this shipping booking?</small>
                  <vs-input :disabled = "!isDispatchBooked" type="number" v-on:input="onChangeSeparateItemCount()" v-model="separate_item_count" name="separate_item_count" class="w-full"
                            label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <vs-table stripe class="mb-8" :data="createForm.package_details">

            <template slot="thead">
<!--              <vs-th class="text-xs" width="15%">ORDER CODE</vs-th>-->
              <vs-th class="text-xs" width="25%">ITEM DESCRIPTION</vs-th>
              <vs-th class="text-xs" width="15%">GROSS WEIGHT (KG)</vs-th>
              <vs-th class="text-xs" width="15%">NET WEIGHT (KG)</vs-th>
              <vs-th class="text-xs" width="15%">LENGTH (cm)</vs-th>
              <vs-th class="text-xs" width="15%">WIDTH (cm)</vs-th>
              <vs-th class="text-xs" width="15%">HEIGHT (cm)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

<!--                <vs-td :data="data[indextr].product_order_code">-->
<!--                  <a class="text-primary" v-on:click="onCLickViewProductOrder(data[indextr].customer_order_id)" > {{ data[indextr].product_order_code  }}</a>-->
<!--                </vs-td>-->

                <vs-td :data="data[indextr].item_number">
                  <ValidationProvider :vid="indextr+'pallet_number'" :name="indextr+'pallet_number'" rules="" v-slot="{ errors }">
                    <vs-input :disabled = "!isDispatchBooked" type="text" v-model="data[indextr].item_number" class="w-full"
                              :name="indextr+'pallet_number'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>

                </vs-td>

                <vs-td :data="data[indextr].gross_weight">
                  <ValidationProvider :vid="indextr+'gross_weight'" :name="indextr+'gross_weight'" rules="required" v-slot="{ errors }">
                    <vs-input :disabled = "!isDispatchBooked" type="text" v-model="data[indextr].gross_weight" class="w-full"
                              :name="indextr+'gross_weight'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="data[indextr].net_weight">
                  <ValidationProvider :vid="indextr+'net_weight'" :name="indextr+'net_weight'" rules="required" v-slot="{ errors }">
                    <vs-input :disabled = "!isDispatchBooked" type="text" v-model="data[indextr].net_weight" class="w-full"
                              :name="indextr+'net_weight'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="data[indextr].cubic_meter_lenght">
                  <ValidationProvider :vid="indextr+'cubic_meter_lenght'" :name="indextr+'cubic_meter_lenght'" rules="required" v-slot="{ errors }">
                    <vs-input :disabled = "!isDispatchBooked" type="text" v-model="data[indextr].cubic_meter_lenght" class="w-full"
                              :name="indextr+'cubic_meter_lenght'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="data[indextr].cubic_meter_width">
                  <ValidationProvider :vid="indextr+'cubic_meter_width'" :name="indextr+'cubic_meter_width'" rules="required" v-slot="{ errors }">
                    <vs-input :disabled = "!isDispatchBooked" type="text" v-model="data[indextr].cubic_meter_width" class="w-full"
                              :name="indextr+'cubic_meter_width'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

                <vs-td :data="data[indextr].cubic_meter">
                  <ValidationProvider :vid="indextr+'cubic_meter_height'" :name="indextr+'cubic_meter_height'" rules="required" v-slot="{ errors }">
                    <vs-input :disabled = "!isDispatchBooked" type="text" v-model="data[indextr].cubic_meter_height" class="w-full"
                              :name="indextr+'cubic_meter_height'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>


              </vs-tr>
            </template>
          </vs-table>
          </vx-card-custom>

          <div class="vx-row mb-3 mt-8">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              Ship by limited quantity
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <vs-switch :disabled = "!isDispatchBooked" color="primary" v-on:input="onChangeDgnRequired()" v-model="createForm.is_hazardous" icon-pack="feather" class="w-16">
                <span slot="on">DGN</span>
                <span slot="off">SLQ</span>
              </vs-switch>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
              DGN Required
            </vs-col>
          </div>

          <span v-if="!createForm.is_shipped_by_limited_quantity && createForm.is_hazardous">
              <vs-row vs-w="12" class="mt-8">
                     <vs-col v-for="(dangerous, index_dangerous) in createForm.dangerous_goods_details"
                             :key="index_dangerous"
                             vs-type="flex"
                             vs-justify="center"
                             vs-align="center"
                             vs-lg="12" vs-sm="12" vs-xs="12"
                             class="px-4 pb-4">
                       <vx-card-custom :title="dangerous.product_code" v-on:remove="onDeleteDangerousItem(dangerous.product_code)" :cardBorder="true" no-shadow :remove-card-action="false" :collapse-action="false">

                         <div class="vx-row mb-3">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'product_code'"
                                                :name="index_dangerous+'product_code'" rules="required"
                                                v-slot="{ errors }">
                              <small class="label">Product Code</small>
                              <vs-input v-model="dangerous.product_code" name="product_code" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'legal_name'" :name="index_dangerous+'legal_name'"
                                                rules="required" v-slot="{ errors }">
                              <small class="label">Legal Name</small>
                              <vs-input v-model="dangerous.legal_name" name="legal_name" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>
                         <div class="vx-row mb-3">
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                               <ValidationProvider :vid="index_dangerous+'un_number'"
                                                   :name="index_dangerous+'un_number'" rules="required"
                                                   v-slot="{ errors }">
                                 <small class="label">UN Number</small>
                                 <vs-input v-model="dangerous.un_number" name="un_number" class="w-full" label=""
                                           :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                           val-icon-pack="feather"/>
                               </ValidationProvider>
                          </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                               <ValidationProvider :vid="index_dangerous+'hazard_class_number'"
                                                   :name="index_dangerous+'hazard_class_number'" rules="required"
                                                   v-slot="{ errors }">
                                 <small class="label">Transport Hazard Class</small>
                                 <vs-input v-model="dangerous.hazard_class_number" name="hazard_class_number"
                                           class="w-full" label=""
                                           :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                           val-icon-pack="feather"/>
                               </ValidationProvider>
                          </div>
                         </div>
                         <div class="vx-row mb-3">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'tunnel_code'"
                                                :name="index_dangerous+'tunnel_code'" rules="required"
                                                v-slot="{ errors }">
                              <small class="label">Tunnel Code</small>
                              <vs-input v-model="dangerous.tunnel_code" name="tunnel_code" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'packing_group'" :name="index_dangerous+'packing_group'"
                                                rules="required" v-slot="{ errors }">
                              <small class="label">Packing Group</small>
                              <vs-input v-model="dangerous.packing_group" name="packing_group" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>
                         <div class="vx-row mb-3">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'flash_point'"
                                                :name="index_dangerous+'flash_point'" rules="required"
                                                v-slot="{ errors }">
                              <small class="label">Flash Point</small>
                              <vs-input v-model="dangerous.flash_point" name="flash_point" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                          <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'emergency_contact'" :name="index_dangerous+'emergency_contact'"
                                                rules="required" v-slot="{ errors }">
                              <small class="label">Emergency Contact</small>
                              <vs-input v-model="dangerous.emergency_contact" name="emergency_contact" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>


                         <div class="vx-row mb-3">
                          <div class="vx-col md:w-full w-full md:mb-0">
                            <ValidationProvider :vid="index_dangerous+'description'" :name="index_dangerous+'description'"
                                                rules="required" v-slot="{ errors }">
                              <small class="label">Proper Shipping name</small>
                              <vs-input v-model="dangerous.description" name="description" class="w-full" label=""
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                        val-icon-pack="feather"/>
                            </ValidationProvider>
                          </div>
                        </div>

                       </vx-card-custom>
                     </vs-col>
              </vs-row>
            </span>




          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.notes" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'create-edit-goods-out-logistics'" v-if="createForm.status.name === 'Dispatch Booked'" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button v-can="'create-edit-goods-out-logistics'" v-else @click.prevent="saveActualDeliveryDate(true)" type="filled" class="ml-auto mt-2">Save Delivery Details</vs-button>
            <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <vs-popup @close="onClosePod()" class="shipment-document-popup" title="SHIPMENT DOCUMENTS" :active.sync="podPopup">
      <!-- Header Actions Toolbar -->
      <div class="doc-toolbar-card flex items-center justify-between flex-wrap">
        <div class="mb-2 sm:mb-0">
          <h5 class="font-semibold text-base mb-1" v-if="!isOnDocumentUploadMode">
            Attached Documents ({{ (documents || []).length }})
          </h5>
          <h5 class="font-semibold text-base mb-1" v-else>
            Upload Shipment Documents
          </h5>
          <span class="text-xs text-muted">Manage proof of delivery, dispatch notes, and shipment labels</span>
        </div>
        <div class="flex items-center">
          <vs-button
            v-if="isOnDocumentUploadMode"
            @click="isOnDocumentUploadMode = false"
            size="small"
            color="secondary"
            type="border"
            icon-pack="feather"
            icon="icon-arrow-left"
            class="mr-2">
            Back to Documents
          </vs-button>
          <vs-button
            v-if="!isOnDocumentUploadMode"
            v-can="'create-edit-goods-out-logistics'"
            @click.stop="isOnDocumentUploadMode = true"
            size="small"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-upload">
            Upload New Document
          </vs-button>
        </div>
      </div>

      <shipment-document-view
        v-bind:shipment_id="id"
        v-if="isOnDocumentUploadMode"
        @onSuccessDocumentUpload="onSuccessDocUpload()"/>

      <vs-collapse type="margin" v-if="!isOnDocumentUploadMode" class="mt-2">
        <vs-collapse-item v-for="(type, index_type) in allDocumentCategories" :key="index_type">
          <div slot="header" class="doc-section-header">
            <div class="flex items-center font-medium">
              <feather-icon :icon="getCategoryIcon(type)" svgClasses="w-5 h-5 mr-2 text-primary" />
              <span>{{ type }}</span>
            </div>
            <vs-chip color="primary" class="text-xs font-semibold">
              {{ getDocumentsByType(type).length }}
            </vs-chip>
          </div>

          <!-- Empty State -->
          <div v-if="getDocumentsByType(type).length === 0" class="doc-empty-state">
            <feather-icon icon="FileTextIcon" svgClasses="w-8 h-8 mb-2 opacity-50 text-grey" />
            <p class="text-sm font-medium mb-1">No {{ type }} uploaded</p>
            <span class="text-xs text-muted mb-3">Upload files related to {{ type }}</span>
            <vs-button
              v-can="'create-edit-goods-out-logistics'"
              @click.stop="isOnDocumentUploadMode = true"
              size="small"
              type="border"
              color="primary"
              icon-pack="feather"
              icon="icon-plus">
              Upload Now
            </vs-button>
          </div>

          <!-- Document List Grid -->
          <div v-else class="doc-grid">
            <div
              class="doc-card"
              v-for="(doc, index_doc) in getDocumentsByType(type)"
              :key="doc.id || index_doc">
              <div>
                <div class="doc-card-header">
                  <div class="doc-icon-wrapper" :class="getFileTypeClass(doc.url)">
                    <feather-icon :icon="getFileIcon(doc.url)" svgClasses="w-5 h-5" />
                  </div>
                  <div class="doc-title-info">
                    <a
                      @click.prevent="onClickDoc(doc.url)"
                      href="javascript:void(0)"
                      class="doc-name"
                      :title="__nameSplitter(doc.url)">
                      {{ __nameSplitter(doc.url) }}
                    </a>
                    <span class="doc-ext-badge">{{ getFileExtension(doc.url) }}</span>
                  </div>
                </div>

                <div class="doc-card-body" v-if="doc.description || doc.staff">
                  <div v-if="doc.description" class="doc-desc" :title="doc.description">
                    <feather-icon icon="AlignLeftIcon" svgClasses="w-3 h-3 mr-1 inline" />
                    <span>{{ doc.description }}</span>
                  </div>
                  <div v-if="doc.staff" class="doc-staff">
                    <feather-icon icon="UserIcon" svgClasses="w-3.5 h-3.5 mr-1" />
                    <span>{{ doc.staff }}</span>
                  </div>
                </div>
              </div>

              <div class="doc-card-footer">
                <vs-button
                  @click="onClickDoc(doc.url)"
                  size="small"
                  type="border"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-external-link"
                  class="doc-btn-view">
                  View
                </vs-button>
                <vx-tooltip text="Remove document" position="top">
                  <vs-button
                    v-can="'create-edit-goods-out-logistics'"
                    @click="onClickRemoveDocument(doc.id)"
                    size="small"
                    type="border"
                    color="danger"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    class="doc-btn-remove">
                    Remove
                  </vs-button>
                </vx-tooltip>
              </div>
            </div>
          </div>
        </vs-collapse-item>
      </vs-collapse>
    </vs-popup>
    <shipment-delivery-note-document-pop-up ref="shipmentDeliveryNoteDocumentPopUp"/>
    <shipment-delivery-note-pdf-pop-up ref="shipmentDeliveryNotePdfPopUp"/>
    <delivery-note ref="deliveryNote"/>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const CourierRepository = RepositoryFactory.get('courier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const RegionsRepository = RepositoryFactory.get('regions');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  import ShipmentDocumentView from "@/components/popups/courier/courier-shipment/documents/ShipmentDocumentView";
  import ShipmentDeliveryNoteDocumentPopUp
    from "@/components/popups/courier/courier-shipment/documents/ShipmentDeliveryNoteDocumentPopUp";
  import ShipmentDeliveryNotePdfPopUp
    from "@/components/popups/courier/courier-shipment/documents/ShipmentDeliveryNotePdfPopUp";
    import DeliveryNote from '@/components/popups/pdf/DeliveryNote.vue';

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  function initialState() {
    return {
      open: false,
      podPopup: false,
      file: {},
      createForm: {
        delivery_address: {
          address_line_1: '',
          address_line_2: '',
          address_line_3: '',
          town_state: '',
          postcode: '',
          country: ''
        },
        transport_mode: null,
        sub_transport_type: null,
        is_hazardous: false,
        dangerous_goods_details: [],
        status: {
          name: ''
        },
        supplier: {
          company_name: ''
        },
        product_items: [],
        package_details: [],
        product_order_invoices: [],
      },
      id: '',
      selected: [],
      product_order_items: [],
      courier_suppliers: [],
      countryCodes: [],
      customerUsers: [],
      types: ['Pallet', 'Small Pack'],
      transport_modes: [
        { label: 'Air', value: 'air' },
        { label: 'Road', value: 'road' }
      ],
      sub_transport_types: [
        { label: 'Cargo', value: 'cargo' },
        { label: 'Passenger', value: 'passenger' }
      ],
      separate_item_count: 0,
      documents: [],
      isOnDocumentUploadMode: false,
      sage_departments:[],
      regions:[],
      updateDeliveryTimer: null,
      showBulkApply: false,
      bulk_awb_consignment_number: '',
      bulk_actual_delivery_date: '',
    }
  }

export default {
  name: 'CreateProductOrderShipmentPopUp',
  data () {
    return initialState()
  },
  computed: {
    isDispatchBooked(){
      return this.createForm.status.name === 'Dispatch Booked'
    },
    allDocumentCategories() {
      const defaultCategories = ['Proof of Delivery', 'Dispatch Note', 'DHL Shipment Label']
      if (!this.documents || !Array.isArray(this.documents)) return defaultCategories
      const existingTypes = this.documents.map((d) => d.type).filter((t) => t && !defaultCategories.includes(t))
      return [...defaultCategories, ...new Set(existingTypes)]
    }
  },
  methods:{
    async openPopup (id) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        await this.getShipmentDetails()
        await this.getSageDepartments()
        await this.getRegions()
        this.open = true;
      } catch (error) {

      }
    },
    async onClickOpenPod() {
      const { data } = (await CourierRepository.getShipmentDocuments(this.id)).data
      this.documents = data
      this.podPopup = true
    },
    async onClickDeliveryNote() {
      this.open = false
      // await this.$refs.shipmentDeliveryNoteDocumentPopUp.openPopup(this.id, this.createForm.courier_shipment_code)
      // await this.$refs.shipmentDeliveryNotePdfPopUp.openPopup(this.id)
      await this.$refs.deliveryNote.openPopup(this.id, this.createForm.customer_id)
    },

    onChangeTransportMode() {
      if (this.createForm.transport_mode !== 'air') {
        this.createForm.sub_transport_type = null
      }
    },

    async getShipmentDetails() {
      await this.$vs.loading()
      try {
        const {data} = (await CourierRepository.getShipmentDetails(this.id)).data
        this.createForm = data
        this.createForm.product_order_invoices = data.product_order_invoices || []
        this.selected = this.createForm.product_items
        this.separate_item_count = this.createForm.package_details.length
        this.createForm.sage_department_id = data.sage_department.id
        this.createForm.region_id = data.region.id

        // this.createForm.work_orders.forEach((n) => {
        //   this.selected = this.selected.map((m) => {
        //     const find = m.work_orders.find((k) => k.id === n.id)
        //     if(find) {
        //       m.work_orders = []
        //       m.work_orders.push(n)
        //     }
        //     return m
        //   })
        // })

        this.selected = this.selected.map((n) => {
          let work_orders = []
          n.work_orders.forEach((m) => {
            const find = this.createForm.work_orders.find((k) => k.id === m.id)
            if(find) {
              work_orders.push(find)
            }
          })
          n.work_orders = work_orders
          return n
        })

      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
      this.dataLoaded = true
    },
    async saveActualDeliveryDate(showToast = true) {
      clearTimeout(this.updateDeliveryTimer)
      this.$vs.loading()
      try {
        const payload = {
          product_items: this.createForm.product_items.map(item => ({
            item_id: item.id,
            actual_delivery_date: item.actual_delivery_date,
            awb_consignment_number: item.awb_consignment_number || '',
          })),
          notes: this.createForm.notes || ''
        }

        await CourierRepository.updateActualDeliveryDate(this.id, payload)
        if (showToast) {
          this.showSuccessMessage('Shipment delivery details updated successfully')
        }
      } catch (e) {
        console.error(e)
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close()
      }
    },
    async updateActualDeliveryDate(){
      clearTimeout(this.updateDeliveryTimer)

      this.updateDeliveryTimer = setTimeout(async () => {
        await this.saveActualDeliveryDate(true)
      }, 800)
    },
    async onClickApplyToAllItems() {
      if (!this.bulk_awb_consignment_number && !this.bulk_actual_delivery_date) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Please enter an AWB / Consignment Number or select an Actual Delivery Date',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      if (this.createForm.product_items && this.createForm.product_items.length > 0) {
        this.createForm.product_items.forEach(item => {
          if (this.bulk_awb_consignment_number) {
            this.$set(item, 'awb_consignment_number', this.bulk_awb_consignment_number)
          }
          if (this.bulk_actual_delivery_date) {
            this.$set(item, 'actual_delivery_date', this.bulk_actual_delivery_date)
          }
        })
        await this.saveActualDeliveryDate(true)
      }
    },

    async getSageDepartments(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
      this.sage_departments =  data.data
      this.$vs.loading.close()
    },
    async getRegions(){
      this.$vs.loading()
      const {data} = await RegionsRepository.getListOfRegions()
      this.regions =  data.data
      this.$vs.loading.close()
    },

    async onClickUpdateShipment () {
      const vue = this;
      this.$vs.loading()
       try {
        const payload = {}
         Object.assign(payload, this.createForm)
         payload.cost_of_delivery = Number(payload.cost_of_delivery).toFixed(2)

         if(this.selected.length !== 0) {
           payload.product_items = this.createForm.product_items.map((n) => {
             return {
               item_id: n.id, 
               quantity: n.shipping_quantity+'', 
               actual_delivery_date: n.actual_delivery_date || '',
             }
           })
           const available_item_ids = this.selected.map(s => s.id)
           payload.product_items = payload.product_items.filter(p => available_item_ids.includes(p.item_id))
         } else {
           payload.product_items = []
         }
         //MAP WORK ORDERS
         let wo_arr = []
         this.selected.forEach((x) => {
           wo_arr = [...wo_arr, ...x.work_orders]
         })

         payload.work_orders = wo_arr.map((n) => {
           return {work_order_id: n.id, quantity: n.shipping_quantity, pack_size: Number(n.pack_size).toFixed(2)}
         })
         //END OF MAP WORK ORDERS

         if (payload.is_hazardous) {
           payload.is_shipped_by_limited_quantity = false
           delete payload.dangerous_goods_details
         } else {
           payload.is_shipped_by_limited_quantity = true
           payload.dangerous_goods_details = []
         }

         if (payload.package_details.length > 0) {
           payload.package_details = payload.package_details.map((n) => {
             return {
               customer_order_id: n.customer_order_id,
               item_number: n.item_number,
               gross_weight: Number(n.gross_weight).toFixed(3),
               net_weight : Number(n.net_weight).toFixed(3),
               cubic_meter_lenght : Number(n.cubic_meter_lenght).toFixed(3),
               cubic_meter_width : Number(n.cubic_meter_width).toFixed(3),
               cubic_meter_height : Number(n.cubic_meter_height).toFixed(3),
             }
           })
         } else {
           payload.package_details = []
         }

         if (payload.transport_mode !== 'air') {
           payload.sub_transport_type = null
         }

         await CourierRepository.updateProductItemCourierShipment(this.id, payload)
         this.showSuccessMessage('Courier shipment updated')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async onCLickViewProductOrder(id) {
      this.open = false
      this.$router.push({path: `/pages/product-orders/${id}`})
    },
    onDeleteDangerousItem(product_code) {
      this.createForm.dangerous_goods_details = this.createForm.dangerous_goods_details.filter((n) => n.product_code !== product_code)
    },
    checkItemInDangerList(product_code) {
      const find = this.createForm.dangerous_goods_details.find((x) => x.product_code === product_code)
      return !find
    },
    addItemToDangerList(item) {
      const obj = {
        product_code: item.formulation_code,
        un_number:  item.dangerous_goods_note ? item.dangerous_goods_note.un_number : '',
        legal_name: '',
        hazard_class_number: item.dangerous_goods_note ? item.dangerous_goods_note.hazard_class_number : '',
        tunnel_code: '',
        packing_group: '',
        flash_point: item.dangerous_goods_note ? item.dangerous_goods_note.flash_point : '' ,
        description: item.dangerous_goods_note ? item.dangerous_goods_note.description : '',
        emergency_contact: '',
        net_weight: item.quantity,
        gross_weight: item.selected_qty,
        cubic_meter: '',
      }
      this.createForm.dangerous_goods_details.push(obj)
    },
    async removeItemFromShipment(data) {
      this.selected = this.selected.filter((x) => x.id !== data.id)
      await this.onClickUpdateShipment()
    },
    async onChangeSeparateItemCount() {
      if(Number(this.separate_item_count) > this.createForm.package_details.length) {
        const diff = Number(this.separate_item_count) - this.createForm.package_details.length
        for (let step = 0; step < diff; step++) {
          await this.onAddSeparateItemToArray()
        }
      } else {
        this.createForm.package_details = []
        for (let step = 0; step < Number(this.separate_item_count); step++) {
          await this.onAddSeparateItemToArray()
        }
      }

    },
    async onAddSeparateItemToArray() {
      const obj = {
        customer_order_id: null,
        order_code: null,
        item_number: '',
        gross_weight: '',
        net_weight: '',
        cubic_meter_lenght: '',
        cubic_meter_width: '',
        cubic_meter_height: ''
      }
      this.createForm.package_details.push(obj)
    },
    onClickDoc(url) {
      window.open(url, '_blank');
    },
    async onSuccessDocUpload() {
      this.isOnDocumentUploadMode = false
      await this.onClickOpenPod()
    },
    onClickViewWorkOrder(id) {
      this.open = false
      this.$router.push({path: `/pages/manufacturing/work-orders/${id}/details`})
    },
    onClosePod() {
      this.isOnDocumentUploadMode = false
    },
    shipmentStatusColorFactory(status) {
      switch (status) {
        case 'Dispatch Booked':
          return 'warning';
        case 'Shipment Dispatched':
          return '#2FDD92';
        case 'Returned':
          return 'danger';
        case 'Customer Received':
          return '#34BE82';
        case 'Cancelled':
          return 'danger';

      }
    },
    getDocumentsByType(type) {
      if (!this.documents || !Array.isArray(this.documents)) return []
      return this.documents.filter((doc) => doc.type === type)
    },
    getCategoryIcon(type) {
      switch (type) {
        case 'Proof of Delivery':
          return 'CheckCircleIcon'
        case 'Dispatch Note':
          return 'FileTextIcon'
        case 'DHL Shipment Label':
          return 'TagIcon'
        default:
          return 'FileIcon'
      }
    },
    getFileExtension(url) {
      if (!url) return 'FILE'
      const cleanUrl = url.split('?')[0]
      const ext = cleanUrl.split('.').pop().toUpperCase()
      return ext && ext.length <= 5 ? ext : 'FILE'
    },
    getFileIcon(url) {
      if (!url) return 'FileIcon'
      const cleanUrl = url.split('?')[0].toLowerCase()
      const ext = cleanUrl.split('.').pop()
      if (['pdf'].includes(ext)) return 'FileTextIcon'
      if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext)) return 'ImageIcon'
      return 'FileIcon'
    },
    getFileTypeClass(url) {
      if (!url) return ''
      const cleanUrl = url.split('?')[0].toLowerCase()
      const ext = cleanUrl.split('.').pop()
      if (['pdf'].includes(ext)) return 'pdf'
      if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext)) return 'img'
      if (['xls', 'xlsx', 'csv'].includes(ext)) return 'excel'
      if (['doc', 'docx'].includes(ext)) return 'doc'
      return ''
    },
    async onClickRemoveDocument(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to remove this document?',
        accept: async () => {
          await this.$vs.loading()
          try {
            await CourierRepository.deleteShipmentDoc(id)
            await this.onClickOpenPod()
            this.showSuccessMessage('Document removed successfully')
          } catch (e) {
            this.convertAndNotifyError(e)
          } finally {
            await this.$vs.loading.close()
          }
        }
      })
    },
    async onClickViewNewShipment() {
      await this.openPopup(this.createForm.related_new_shipment.id)
    },
    async onClickViewReturnedShipment() {
      await this.openPopup(this.createForm.related_returened_shipment.id)
    },
    checkAbilityToDispatch(work_orders) {
        let count = 0
        work_orders.forEach((n) => {
          if(n.status.name === 'Pack Off Completed' && n.q_c_test_status === 'Approved by QC') {
            count++
          }
        })
        return count === work_orders.length
    },
    async onClickShipmentStatusChangeConfirm(status) {
      this.open = false
        this.$vs.dialog({
            type: 'confirm',
            color: `${status !== 'cancelled' ? 'warning' : 'danger'}`,
            title: `Confirm`,
            text: `${status !== 'cancelled' ? 'Are you sure you want to make this change?' : 'Are you sure you want to cancel this shipment?'}`,
            accept: this.onClickShipmentStatusChange,
            cancel: () => { this.open = true },
            parameters: [status]
        })
    },
    async onClickShipmentStatusChange(params) {
        await this.$vs.loading()
        try {
          await CourierRepository.shipmentStatusChange(this.createForm.id, params[0])
          await this.$parent.refreshData()
          this.showSuccessMessage('Courier shipment status change successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    flatPickr,
    ShipmentDocumentView,
    ShipmentDeliveryNoteDocumentPopUp,
    ShipmentDeliveryNotePdfPopUp,
    DeliveryNote,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .shipment-update-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
  }
  .shipment-document-popup >>> .vs-popup {
    min-height: 50% !important;
    min-width: 75% !important;
  }

  .shipment-document-popup >>> .vs-popup--content {
    padding: 16px 20px 24px 20px !important;
  }

  .doc-toolbar-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    margin: 8px 0 20px 0;
    padding: 16px 20px;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  }

  .shipment-document-popup >>> .con-content--item {
    padding: 16px 20px 24px 20px !important;
  }

  .shipment-document-popup >>> .vs-collapse.margin .vs-collapse-item {
    margin-top: 14px !important;
    margin-bottom: 14px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    border: 1px solid #ebedf0;
  }

  .doc-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 4px 12px 4px 0;
  }

  .doc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 340px));
    gap: 20px;
    padding: 4px;
    margin: 8px 0 16px 0;
  }

  .doc-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.25s ease-in-out;
    position: relative;
    overflow: hidden;
    margin: 0;
  }

  .doc-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    border-color: rgba(var(--vs-primary), 0.5);
  }

  .doc-card-header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 10px;
  }

  .doc-icon-wrapper {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #f0f4f8;
    color: #4a5568;
  }

  .doc-icon-wrapper.pdf {
    background: #fee2e2;
    color: #ef4444;
  }

  .doc-icon-wrapper.img {
    background: #e0f2fe;
    color: #0284c7;
  }

  .doc-icon-wrapper.excel {
    background: #dcfce7;
    color: #16a34a;
  }

  .doc-icon-wrapper.doc {
    background: #e0e7ff;
    color: #4f46e5;
  }

  .doc-title-info {
    flex: 1;
    min-width: 0;
  }

  .doc-name {
    display: block;
    font-weight: 600;
    font-size: 0.92rem;
    color: #1e293b;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
    cursor: pointer;
    transition: color 0.2s;
  }

  .doc-name:hover {
    color: rgba(var(--vs-primary), 1);
    text-decoration: underline;
  }

  .doc-ext-badge {
    display: inline-block;
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    padding: 2px 6px;
    border-radius: 4px;
    background: #f1f5f9;
    color: #64748b;
    text-transform: uppercase;
  }

  .doc-card-body {
    margin-top: 6px;
    margin-bottom: 14px;
    font-size: 0.82rem;
    color: #64748b;
  }

  .doc-desc {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 8px;
    padding: 8px 10px;
    background: #f8fafc;
    border-radius: 6px;
    color: #334155;
    font-size: 0.8rem;
    line-height: 1.3;
  }

  .doc-staff {
    display: flex;
    align-items: center;
    font-size: 0.78rem;
    color: #94a3b8;
  }

  .doc-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    border-top: 1px solid #f1f5f9;
    gap: 10px;
  }

  .doc-btn-view {
    flex: 1;
  }

  .doc-btn-remove {
    flex-shrink: 0;
  }

  .doc-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 28px 20px;
    color: #94a3b8;
    text-align: center;
    background: #f8fafc;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    margin: 10px 4px 16px 4px;
  }

  /* Dark mode overrides */
  ::v-deep .theme-dark .doc-toolbar-card,
  .theme-dark .doc-toolbar-card {
    background: #1e2542;
    border-color: #414561;
  }

  ::v-deep .theme-dark .shipment-document-popup .vs-collapse.margin .vs-collapse-item,
  .theme-dark .shipment-document-popup .vs-collapse.margin .vs-collapse-item {
    border-color: #414561;
    background: #1e2542;
  }

  ::v-deep .theme-dark .doc-card,
  .theme-dark .doc-card {
    background: #262c49;
    border-color: #414561;
  }

  ::v-deep .theme-dark .doc-card:hover,
  .theme-dark .doc-card:hover {
    border-color: rgba(var(--vs-primary), 0.7);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }

  ::v-deep .theme-dark .doc-name,
  .theme-dark .doc-name {
    color: #c2c6dc;
  }

  ::v-deep .theme-dark .doc-ext-badge,
  .theme-dark .doc-ext-badge {
    background: #10163a;
    color: #8487a0;
  }

  ::v-deep .theme-dark .doc-desc,
  .theme-dark .doc-desc {
    background: #10163a;
    color: #c2c6dc;
  }

  ::v-deep .theme-dark .doc-staff,
  .theme-dark .doc-staff {
    color: #8487a0;
  }

  ::v-deep .theme-dark .doc-card-footer,
  .theme-dark .doc-card-footer {
    border-top-color: #414561;
  }

  ::v-deep .theme-dark .doc-empty-state,
  .theme-dark .doc-empty-state {
    background: #10163a;
    border-color: #414561;
    color: #8487a0;
  }

  .bulk-apply-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px 16px;
    transition: all 0.3s ease;
  }

  .bulk-apply-card:hover {
    border-color: rgba(var(--vs-primary), 0.5);
  }

  .bulk-date-picker {
    height: 38px;
    padding: 0 12px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    outline: none;
  }

  /* Dark mode overrides for bulk card */
  ::v-deep .theme-dark .bulk-apply-card,
  .theme-dark .bulk-apply-card {
    background: #1e2542;
    border-color: #414561;
  }

  ::v-deep .theme-dark .bulk-apply-card .border-t,
  .theme-dark .bulk-apply-card .border-t {
    border-top-color: #414561 !important;
  }

  ::v-deep .theme-dark .bulk-date-picker,
  .theme-dark .bulk-date-picker {
    background: #262c49;
    border-color: #414561;
    color: #c2c6dc;
  }
</style>
